webpackJsonp([9,11],{

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _mutationTypes = __webpack_require__(16);
	
	exports.default = {
	    data: function data() {
	        return {
	            loading: false,
	            recordsStatus: '100',
	            dateRange: '',
	            page: 1
	        };
	    },
	
	    computed: {
	        disablePreview: function disablePreview() {
	            return this.page == 1;
	        },
	        disableNext: function disableNext() {
	            return this.recordsData.length < 20;
	        },
	        showRecordsBtn: function showRecordsBtn() {
	            return !this.disablePreview || !this.disableNext;
	        },
	        recordsType: function recordsType() {
	            return this.$route.params.type;
	        },
	        recordsData: function recordsData() {
	            if (this.recordsType === 'consume') {
	                return this.$store.getters.consumeRecordsList;
	            }
	            if (this.recordsType === 'recharge') {
	                return this.$store.getters.rechargeRecordsList;
	            }
	            return [];
	        },
	        startDate: function startDate() {
	            return this.formatData(0);
	        },
	        endDate: function endDate() {
	            return this.formatData(1);
	        },
	        dateRangeOptions: function dateRangeOptions() {
	            return {
	                shortcuts: [{
	                    text: this.$t('lastWeek'),
	                    onClick: function onClick(picker) {
	                        var end = new Date();
	                        var start = new Date();
	                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
	                        picker.$emit('pick', [start, end]);
	                    }
	                }, {
	                    text: this.$t('lastMonth'),
	                    onClick: function onClick(picker) {
	                        var end = new Date();
	                        var start = new Date();
	                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
	                        picker.$emit('pick', [start, end]);
	                    }
	                }, {
	                    text: this.$t('lastThreeMonth'),
	                    onClick: function onClick(picker) {
	                        var end = new Date();
	                        var start = new Date();
	                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
	                        picker.$emit('pick', [start, end]);
	                    }
	                }]
	            };
	        },
	        recordsStatusOptions: function recordsStatusOptions() {
	            return [{
	                value: '0',
	                label: this.$t('statusPending')
	            }, {
	                value: '100',
	                label: this.$t('statusSuccess')
	            }, {
	                value: '-50',
	                label: this.$t('statusFail')
	            }];
	        }
	    },
	    methods: {
	        formatData: function formatData(num) {
	            if (this.dateRange) {
	                var startDate = this.dateRange[num];
	                return startDate.getUTCFullYear() + "-" + (startDate.getUTCMonth() + 1) + "-" + startDate.getUTCDate();
	            }
	            return "";
	        },
	        getRecords: function getRecords() {
	            this.loading = true;
	            var that = this;
	            var apiParams = {
	                recordsType: this.recordsType,
	                uid: this.$store.state.user.uid,
	                page: this.page,
	                recordsStatus: this.recordsStatus,
	                startDate: this.startDate,
	                endDate: this.endDate
	            };
	
	            this.$store.dispatch([_mutationTypes.GET_RECORDS], apiParams).then(function () {
	                that.loading = false;
	            }).catch(function (errorCode) {
	                that.loading = false;
	                if (errorCode === -1) {
	                    that.$message.error(that.$t('systemErrorTryLater'));
	                } else {
	                    that.$message.error('Get records failed: ' + errorCode);
	                }
	            });
	        },
	        getPreviewRecords: function getPreviewRecords() {
	            if (this.page > 1) {
	                this.page = this.page - 1;
	                this.getRecords();
	            }
	        },
	        getNextRecords: function getNextRecords() {
	            this.tableData = [];
	            this.page = this.page + 1;
	            this.getRecords();
	        }
	    },
	    created: function created() {
	        this.getRecords();
	    },
	
	    watch: {
	        '$route': function $route(to, from) {
	            this.recordsType = to.params.type;
	            this.recordsData = [];
	            this.recordsStatus = '100';
	            this.dateRange = '';
	            this.page = 1;
	            this.getRecords();
	        }
	    }
	};

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".blank[data-v-c6f24a02]{visibility:hidden;height:0}.store-content[data-v-c6f24a02]{background:none;border:none;padding:0;min-height:500px}.record-date[data-v-c6f24a02]{margin:0 50px}.records-select[data-v-c6f24a02]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;margin:10px auto 50px}.records-table[data-v-c6f24a02]{margin:0 auto}.date-range-picker[data-v-c6f24a02]{width:220px}.records-btn[data-v-c6f24a02]{margin-top:35px;-ms-flex-item-align:end;align-self:flex-end;margin-right:25px}.el-button[data-v-c6f24a02]{width:85px}", "", {"version":3,"sources":["/./src/components/store/Records.vue"],"names":[],"mappings":"AACA,wBAAwB,kBAAkB,QAAQ,CACjD,AACD,gCAAgC,gBAAgB,YAAY,UAAU,gBAAgB,CACrF,AACD,8BAA8B,aAAa,CAC1C,AACD,iCAAiC,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,mBAAmB,qBAAqB,CACzP,AACD,gCAAgC,aAAa,CAC5C,AACD,oCAAoC,WAAW,CAC9C,AACD,8BAA8B,gBAAgB,wBAAwB,oBAAoB,iBAAiB,CAC1G,AACD,4BAA4B,UAAU,CACrC","file":"Records.vue","sourcesContent":["\n.blank[data-v-c6f24a02]{visibility:hidden;height:0\n}\n.store-content[data-v-c6f24a02]{background:none;border:none;padding:0;min-height:500px\n}\n.record-date[data-v-c6f24a02]{margin:0 50px\n}\n.records-select[data-v-c6f24a02]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;margin:10px auto 50px\n}\n.records-table[data-v-c6f24a02]{margin:0 auto\n}\n.date-range-picker[data-v-c6f24a02]{width:220px\n}\n.records-btn[data-v-c6f24a02]{margin-top:35px;-ms-flex-item-align:end;align-self:flex-end;margin-right:25px\n}\n.el-button[data-v-c6f24a02]{width:85px\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(261);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-c6f24a02&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Records.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-c6f24a02&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Records.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(313)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(165),
	  /* template */
	  __webpack_require__(391),
	  /* scopeId */
	  "data-v-c6f24a02",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 391:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "records-select"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('orderStatus')) + "：")]), _vm._v(" "), _c('el-select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.recordsStatus),
	      expression: "recordsStatus"
	    }],
	    staticStyle: {
	      "width": "200px"
	    },
	    attrs: {
	      "placeholder": "请选择"
	    },
	    domProps: {
	      "value": (_vm.recordsStatus)
	    },
	    on: {
	      "input": function($event) {
	        _vm.recordsStatus = $event
	      }
	    }
	  }, _vm._l((_vm.recordsStatusOptions), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  })), _vm._v(" "), _c('div', {
	    staticClass: "block record-date"
	  }, [_c('span', {
	    staticClass: "demonstration"
	  }, [_vm._v(_vm._s(_vm.$t('orderDate')) + "：")]), _vm._v(" "), _c('el-date-picker', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dateRange),
	      expression: "dateRange"
	    }],
	    staticClass: "date-range-picker",
	    attrs: {
	      "type": "daterange",
	      "align": "right",
	      "placeholder": _vm.$t('selectDateRange'),
	      "picker-options": _vm.dateRangeOptions,
	      "format": "yyyy/MM/dd"
	    },
	    domProps: {
	      "value": (_vm.dateRange)
	    },
	    on: {
	      "input": function($event) {
	        _vm.dateRange = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.getRecords
	    }
	  }, [_vm._v(_vm._s(_vm.$t('search')))])], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading.body",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "body": true
	      }
	    }],
	    staticClass: "store-content"
	  }, [(!_vm.loading) ? _c('el-table', {
	    staticClass: "records-table",
	    attrs: {
	      "data": _vm.recordsData,
	      "empty-text": _vm.loading ? ' ' : _vm.$t('noRecords')
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "orderDate",
	      "label": _vm.$t('recordDate'),
	      "width": "180",
	      "align": "center"
	    }
	  }), _vm._v(" "), (_vm.recordsType == 'consume') ? [_c('el-table-column', {
	    attrs: {
	      "prop": "appName",
	      "label": _vm.$t('appName'),
	      "align": "center"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "goodsName",
	      "label": _vm.$t('goodsName'),
	      "align": "center"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "goodsPrice",
	      "label": _vm.$t('goodsPrice'),
	      "width": "150",
	      "align": "center"
	    }
	  })] : _vm._e(), _vm._v(" "), (_vm.recordsType == 'recharge') ? [_c('el-table-column', {
	    attrs: {
	      "prop": "channelName",
	      "label": _vm.$t('rechargeChannel'),
	      "align": "center"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "rechargeAmount",
	      "label": _vm.$t('rechargeAmount'),
	      "width": "150",
	      "align": "center"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "egPoint",
	      "label": _vm.$t('egPoint'),
	      "width": "110",
	      "align": "center"
	    }
	  })] : _vm._e(), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "orderId",
	      "label": _vm.$t('orderId'),
	      "width": "180",
	      "align": "center"
	    }
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.showRecordsBtn && !_vm.loading) ? _c('div', {
	    staticClass: "records-btn"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "disabled": _vm.disablePreview
	    },
	    on: {
	      "click": _vm.getPreviewRecords
	    }
	  }, [_vm._v(_vm._s(_vm.$t('previewPage')) + "\n            ")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "disabled": _vm.disableNext
	    },
	    on: {
	      "click": _vm.getNextRecords
	    }
	  }, [_vm._v(_vm._s(_vm.$t('nextPage')) + "\n            ")])], 1) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/9.0f8146195d84283f6158.js